export type { FC } from 'react';

export enum ETabs {
    LIST = 'LIST',
    NOTIFICATIONS = 'NOTIFICATIONS',
}

export interface Props {}
